module.exports = __webpack_public_path__ + "img/jess.4f7df247.jpeg";